import { render, staticRenderFns } from "./ProntuarioProcedimentos.vue?vue&type=template&id=6dea20c3&"
import script from "./ProntuarioProcedimentos.vue?vue&type=script&lang=js&"
export * from "./ProntuarioProcedimentos.vue?vue&type=script&lang=js&"
import style0 from "./ProntuarioProcedimentos.vue?vue&type=style&index=0&id=6dea20c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports